var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{staticClass:"accordion-base",attrs:{"name":"accordion-content"},on:{"enter":_vm.onEnter,"after-enter":_vm.onAfterEnter,"leave":_vm.onLeave,"after-leave":_vm.onAfterLeave}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}]},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }